export enum MassnahmenplanStatus {
    ERSTELLT = 61,
    ABGESCHLOSSEN = 62,
}
